import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { familyApi, errMsg } from './familyApi';
import { CreateAccountForm } from './CreateAccountForm';
import { AccountList } from './AccountList';
import { AccountDetail } from './AccountDetail';
import { WhoHasAccessCalendar } from './WhoHasAccessCalendar';

export const FamilyAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(() => familyApi.list().then((d) => setAccounts(d.accounts)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);

  const upsert = (acc) => setAccounts((prev) => {
    const rest = prev.filter((p) => p.user_id !== acc.user_id);
    return [...rest, acc].sort((x, y) => (x.access.status === 'terminated') - (y.access.status === 'terminated') || x.name.localeCompare(y.name));
  });

  return (
    <div data-testid="family-accounts-manager" className="space-y-6">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold text-sky-900">👨‍👩‍👧‍👦 Family & Friends Accounts</h2>
        <p className="text-slate-600 mt-1 text-sm sm:text-base">
          Create their login, set their password, and choose lifetime access or the exact days they can use the protocol.
          On days without access they can sign in but the protocol and 💀 V4 phone alerts are locked.
        </p>
      </div>
      <CreateAccountForm onCreated={upsert} />
      <AccountList accounts={accounts} onOpen={(a) => setOpenId(a.user_id)} />
      <WhoHasAccessCalendar accounts={accounts} />
      <AccountDetail
        account={accounts.find((a) => a.user_id === openId) || null}
        onClose={() => setOpenId(null)}
        onChanged={upsert}
        onDeleted={(id) => { setOpenId(null); setAccounts((p) => p.filter((x) => x.user_id !== id)); }}
      />
    </div>
  );
};
